/**
 * Rsvp or Reservation
 */
export enum SummaryRecordTypeEnum {
  RSVP = <any>'RSVPs',
  RESERVATION = <any>'Reservations',
  RESERVATION_RSVP = <any>'Reservations & RSVPs',
  ERROR = <any>'error'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/summary-record-type.enum.ts